<template>
  <div class="clear-filters">
    <i class="icon-no-results"></i>

    <span>{{translate('offNoResults')}}</span>

    <button data-testid="clear-filters-button" @click="handleClearFilters">Clear filters</button>
  </div>
</template>

<script>
export default {
  name: 'ClearFilters',
  methods: {
    handleClearFilters() {
      this.$emit('clear-filters')
    }
  }
}
</script>

<style scoped lang="scss">
button {
  box-sizing: border-box;

  background: #ffffff;
  border: 1px solid #c00d0d;
  border-radius: 4px;
  padding: 1rem 1.5rem;
  font-weight: 350;
  font-size: 12px;
  line-height: 14px;

  color: #c00d0d;
}
.clear-filters {
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
</style>
